import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import SVG from 'react-inlinesvg';
import { analyticsTrack } from '../../../analyticsUtils';
import { putRequest } from '../../../requestUtils';
import ProjectLoadingIndicator from '../ProjectLoadingIndicator';
import './ProjectExpertisePriority.scss';
import '../ProjectDetails.scss';
import lineImg from '../../../../assets/images/must-haves-line.svg';
import listImg from '../../../../assets/images/must-haves-list.svg';

const models = [
  'area_of_expertise',
  'therapeutic_area',
  'disease_code',
  'therapy',
  'regulatory_pathway',
  'development_phase',
  'degree',
  'language',
  'skill',
  'accreditation',
];

const formStep = 'expertise-priority';

class ProjectExpertisePriority extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      errors: null,
      expertiseTags: null,
      nonPriorityExpertiseTags: null,
      priorityExpertiseTags: null,
      expertisePicklists: null,
      notApplicable: [],
    };

    this.handleShowModal = this.handleShowModal.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handlePromote = this.handlePromote.bind(this);
    this.handleDemote = this.handleDemote.bind(this);
    this.handleClear = this.handleClear.bind(this);
  }

  componentDidMount() {
    const { projectResourceId, getProjectDetails } = this.props;

    if (!projectResourceId) return;

    getProjectDetails(formStep).then((response) => {
      this.setState({
        expertiseTags: response.data.expertise_tags,
        expertisePicklists: response.data.expertise_picklists,
        priorityExpertiseTags: response.data.priority_expertise_tags,
        nonPriorityExpertiseTags: response.data.non_priority_expertise_tags,
        notApplicable: response.data.not_applicable,
      });
    });
  }

  handleShowModal() {
    this.setState({ showModal: true });
  }

  handleHideModal() {
    this.setState({ showModal: false });
  }

  handleBack() {
    if (this.props.formType === 'page') {
      this.props.back();
    } else {
      this.handleHideModal();
    }
  }

  ableToSubmit() {
    const { priorityExpertiseTags } = this.state;

    let alltags = [];

    models.forEach((model) => {
      alltags = [...alltags, ...priorityExpertiseTags[`${model}_ids`]];
    });
    return alltags.length > 0;
  }

  handleSubmit() {
    const { csrfToken, projectResourceId, afterSubmit } = this.props;
    const { priorityExpertiseTags, nonPriorityExpertiseTags } = this.state;
    const projectAttributes = {};

    models.forEach((model) => {
      // exclude priority tags from non-prefixed list so Rails will delete them and re-add them
      projectAttributes[`non_priority_${model}_ids`] = nonPriorityExpertiseTags[`${model}_ids`];
      projectAttributes[`priority_${model}_ids`] = priorityExpertiseTags[`${model}_ids`];
    });

    putRequest(
      `/projects/${projectResourceId}?form_step=expertise-priority`,
      { project: projectAttributes },
      csrfToken,
    ).then(() => {
      afterSubmit();
    }).catch((error) => {
      this.setState({ errors: error.name });
      return null;
    });
  }

  handlePromote(e) {
    const { nonPriorityExpertiseTags, priorityExpertiseTags } = this.state;
    const { model } = e.target.dataset;
    const { label } = e.target.dataset;

    const priorityTags = priorityExpertiseTags;
    const selectedTag = Number(e.target.dataset.id);
    if ((priorityTags[`${model}_ids`].includes(selectedTag))) {
      return;
    }
    priorityTags[`${model}_ids`].push(selectedTag);

    const nonPriorityTags = nonPriorityExpertiseTags;
    const foundIndex = nonPriorityTags[`${model}_ids`].findIndex(
      (i) => i === Number(e.target.dataset.id),
    );
    nonPriorityTags[`${model}_ids`].splice(foundIndex, 1);

    analyticsTrack(
      `Promoted ${label} to Must-have expertise`,
      { location: 'Project creation' },
    );
    this.setState({
      priorityExpertiseTags: priorityTags,
      nonPriorityExpertiseTags: nonPriorityTags,
    });
  }

  handleDemote(e) {
    const { nonPriorityExpertiseTags, priorityExpertiseTags } = this.state;
    const { model } = e.target.dataset;
    const { label } = e.target.dataset;

    const priorityTags = priorityExpertiseTags;
    const foundIndex = priorityTags[`${model}_ids`].findIndex(
      (i) => i === Number(e.target.dataset.id),
    );
    priorityTags[`${model}_ids`].splice(foundIndex, 1);

    const nonPriorityTags = nonPriorityExpertiseTags;
    nonPriorityTags[`${model}_ids`].push(Number(e.target.dataset.id));

    analyticsTrack(
      `Demoted ${label} from Must-have expertise`,
      { location: 'Project creation' },
    );
    this.setState({
      priorityExpertiseTags: priorityTags,
      nonPriorityExpertiseTags: nonPriorityTags,
    });
  }

  handleClear() {
    const { priorityExpertiseTags, expertiseTags } = this.state;

    const priorityTags = priorityExpertiseTags;
    // TODO: remove eslint disabled line

    const resetTags = structuredClone(expertiseTags);

    models.forEach((model) => {
      priorityTags[`${model}_ids`] = [];
    });

    this.setState({
      priorityExpertiseTags: priorityTags,
      nonPriorityExpertiseTags: resetTags,
    });
  }

  renderModal() {
    return (
      <Modal
        show={this.state.showModal}
        onHide={this.handleHideModal}
        dialogClassName="expertise-priority-modal"
      >
        <Modal.Header closeButton />
        <Modal.Body className="expertise-priority-modal-body">
          {this.renderContent()}
        </Modal.Body>
      </Modal>
    );
  }

  renderButtons() {
    const { backButtonText, submitButtonText } = this.props;

    return (
      <div className="footer-buttons-container mt-4">
        <button className="btn btn-secondary button-back" onClick={this.handleBack}>
          {backButtonText}
        </button>
        <button
          className="btn btn-primary button-submit"
          onClick={this.handleSubmit}
          disabled={!this.ableToSubmit()}
        >
          {submitButtonText}
        </button>
      </div>
    );
  }

  renderErrors() {
    const { errors } = this.state;

    return (errors
      && (
      <div id="error_explanation">
        <h3>Errors prohibited this project from being saved:</h3>
        <ul>
          {errors.map((e) => (
            <li>{e}</li>
          ))}
        </ul>
      </div>
      )
    );
  }

  renderPriorityBadges() {
    const { priorityExpertiseTags } = this.state;
    const className2 = 'tag-container-flex';

    return (
      <div className={className2}>
        {models.map((model) => priorityExpertiseTags[`${model}_ids`].map(
          (id) => this.renderBadge(model, id, true),
        ))}
      </div>
    );
  }

  renderBadges(subheading, model) {
    const { expertiseTags, notApplicable } = this.state;
    const tagIds = expertiseTags[`${model}_ids`] || [];
    const shouldRenderCategory = !notApplicable.includes(model) && tagIds.length > 0;

    return (
      <div className={`tag-container ${model}`}>
        <div className="expertise-tag-dropdown-heading">{subheading}</div>
        <div className="tag-container-flex">
          {shouldRenderCategory ? (
            tagIds.map((id) => this.renderBadge(model, id, false))
          ) : (
            <p>None Selected</p>
          )}
        </div>
      </div>
    );
  }

  renderBadge(model, id, priority) {
    const { expertisePicklists, priorityExpertiseTags } = this.state;
    const picklistTag = expertisePicklists[model].find((tag) => tag.value === id);
    const label = picklistTag && picklistTag.label;
    const selected = priorityExpertiseTags[`${model}_ids`].includes(id);
    const demoteSymbol = (priority ? 'fa-xmark fa-solid right' : 'fa-solid fa-check left');
    const symbolClass = selected ? `fas ${demoteSymbol}` : 'fas fa-plus left';
    const badgeStyleClass = selected ? 'qualification-tag must-haves-tag' : 'expertise-tag-button';
    const action = (selected ? this.handleDemote : this.handlePromote);

    if (!label) return null;
    return (
      <span
        onClick={action}
        data-model={model}
        data-label={label}
        data-id={id}
        key={id}
        className={badgeStyleClass}
        role="button"
        tabIndex={0}
      >

        {priority
          ? (
            <Fragment>
              {label}
          &nbsp;
              <i data-model={model} data-label={label} data-id={id} className={symbolClass} />
            </Fragment>
          )
          : (
            <Fragment>
              <i data-model={model} data-label={label} data-id={id} className={symbolClass} />
           &nbsp;
              {label}
            </Fragment>
          )}
      </span>
    );
  }

  renderContent() {
    const { expertiseTags } = this.state;
    if (!expertiseTags) {
      return (
        <ProjectLoadingIndicator />
      );
    }

    return (
      <div className="style-guide project-expertise-container">
        <div className="g-row">
          <div className="g-column g-flex-1" />
          <div className="g-column g-flex-6 expertise-entry-container expertise-priority">
            {this.renderErrors()}
            <h2>Must-Have Qualifications</h2>
            <p>
              Select the requirements that candidates must have.
              You will only receive proposals from candidates who meet all
              your must-have requirements.
            </p>
            <br />
            {this.renderBadges('Functional Areas', 'area_of_expertise')}
            {this.renderBadges('Therapeutic Areas', 'therapeutic_area')}
            {this.renderBadges('Diseases and Indications', 'disease_code')}
            {this.renderBadges('Product Technologies', 'therapy')}
            {this.renderBadges('Regulatory Pathways', 'regulatory_pathway')}
            {this.renderBadges('Development Phases', 'development_phase')}
            {this.renderBadges('Other Keywords / Skills', 'skill')}
            {this.renderBadges('Language', 'language')}
            {this.renderBadges('Highest Education', 'degree')}
            {this.renderBadges('Certification', 'accreditation')}
            {!this.ableToSubmit()
              && <div id="error_explanation">Select at least 1 must-have</div>}
            {this.renderButtons()}
          </div>

          <div className="g-column g-flex-3 protip-container must-haves">
            <SVG src={listImg} title="Must have list" />
            <div className="must-haves-container">
              <span className="must-haves-title">Must-Have List</span>
              <span
                role="button"
                className="btn"
                tabIndex={0}
                style={{ outline: 0 }}
                onClick={this.handleClear}
              >
                <p className="clear-btn-must-haves">Clear All</p>
              </span>
            </div>
            <img src={lineImg} className="line-img" alt="comments" />
            <div className="subheading must-haves">
              We require all projects to have at least 1 must-have tag
            </div>
            {this.renderPriorityBadges()}
          </div>
        </div>
      </div>
    );
  }

  renderModalLink() {
    return (
      <i
        role="button"
        tabIndex={0}
        className="fa fa-edit modal-link"
        onClick={this.handleShowModal}
      >
        {(this.props.formType === 'modal-link') ? 'Edit' : ''}
      </i>
    );
  }

  render() {
    if (this.props.formType === 'page') {
      return this.renderContent();
    }
    return (
      <div>
        { this.renderModalLink() }
        { this.renderModal() }
      </div>
    );
  }
}

ProjectExpertisePriority.propTypes = {
  formType: PropTypes.string, // one of 'page', 'modal-link', 'modal-icon'
  projectResourceId: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  back: PropTypes.func,
  afterSubmit: PropTypes.func,
  getProjectDetails: PropTypes.func.isRequired,
  backButtonText: PropTypes.string,
  submitButtonText: PropTypes.string,
};

ProjectExpertisePriority.defaultProps = {
  formType: 'page',
  projectResourceId: null,
  back: () => {},
  afterSubmit: () => {},
  backButtonText: 'Back',
  submitButtonText: 'Next',
};

export default ProjectExpertisePriority;
